import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { doctor02 } from "../../constants/images";
import { useDictionary } from "../../contexts/dictionary";
import { useContactType } from "../../contexts/ContactContext";
import { useLocation } from "react-router-dom";
import { Col, VImage } from "../../style/base.style";
import { ProfileImg } from "../common/profileImage";
import { calculateAge } from "../../utils/calculators";
import { useFormHandling } from "../../hooks/formUtils";
import { RequestConfigs } from "../../api";




export const dashboardMenuItems: MenuItem[] = [
    {
        icon: "isax isax-category-2",
        label: "dashboard",
        to: "/dashboard",
    },
    {
        icon: "isax isax-calendar-1",
        label: "my_cases",
        to: "/dashboard/cases",
    },
    // {
    //     icon: "isax isax-star-1",
    //     label: "favourites",
    //     to: "/dashboard/favourites",
    // },
    {
        icon: "isax isax-user-octagon",
        label: "my_family",
        to: "/dashboard/family",
    },
    // {
    //     icon: "isax isax-note-21",
    //     label: "medical_records",
    //     to: "/dashboard/medicalrecords",
    // },
    // {
    //     icon: "isax isax-wallet-2",
    //     label: "wallet",
    //     to: "/dashboard/wallet",
    // },
    {
        icon: "isax isax-document-text",
        label: "invoices",
        to: "/dashboard/invoices",
    },
    {
        icon: "isax isax-messages-1",
        label: "notifications",
        to: "/dashboard/notifications",
    },
    // {
    //     icon: "isax isax-note-1",
    //     label: "vitals",
    //     to: "vitals",
    // },
    {
        icon: "isax isax-setting-2",
        label: "settings",
        to: "/dashboard/profile",
    },
   
];

const logout =  {
  icon: "isax isax-logout",
  label: "logout",
  to: "/dashboard/logout",
}





export const DashboardSidebar = () => {
  
const {contact} = useContactType();
const location = useLocation();
const navigate = useNavigate();
const pageSplit = location.pathname.split('/dashboard/').pop();
const page = pageSplit==='/dashboard' ? "" : pageSplit;
console.log(page,"page");
const {translate} = useDictionary();

const {handleClick,serverRes} = useFormHandling({ requestType: RequestConfigs.logout })
  const handleLogout = () => {
    handleClick()
  }



useEffect(() => {
    if (serverRes) {
        if (serverRes.succeeded) {
            navigate("/login")
        }
    }
}, [serverRes]);

const getLink = (route: string) => {
  if(route.includes('logout')){
   return "#";
  }
  console.log('route',route)
  return `${route}`
}


const age = calculateAge(contact?.Date_of_Birth);

  return (
    <>
      {/* Profile Sidebar */}
      <div className="profile-sidebar patient-sidebar profile-sidebar-new">
        <div className="widget-profile pro-widget-content">
          <div className="profile-info-widget">
            <Link to="/dashboard/profile" className="booking-doc-img">
             <ProfileImg width={120} height={120}/>
            </Link>
            <div className="profile-det-info">
              <h3>
                <Link to="/dashboard/profile">{contact?.Full_Name}</Link>
              </h3>
              
              <span>
                {translate(contact?.Salutation || "")} <i className="fa-solid fa-circle" /> {`${translate(contact?.Salutation==='Miss.'?'girl':'boy')} ${age.years} ${translate('and')}${age.months} ${translate('months')} `}
              </span>
            </div>
          </div>
        </div>
        <div className="dashboard-widget">
          <nav className="dashboard-menu">
          <ul>
            {dashboardMenuItems.map((item, index) => (
              
              <li key={index} className={ (('/dashboard/'+page === item.to)||('/dashboard'+page === item.to)) ? "active" : ""}>
                <Link to={getLink(item.to)} onClick={item.to==='logout'?handleLogout:()=>{}}>
                  <i className={item.icon} />
                  <span>{translate(item.label)}</span>
                </Link>
              </li>
            ))}
             <li key={150} className={ '/dashboard/'+page === logout.to ? "active" : ""}>
                <Link to={getLink(logout.to)} onClick={logout.to==='logout'?handleLogout:()=>{}}>
                  <i className={logout.icon} />
                  <span>{translate(logout.label)}</span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {/* /Profile Sidebar */}
    </>

  );
};
export default DashboardSidebar;
